export const CONSENT_MANAGER_PLUGIN_NAME = 'consent-manager';
